import { useAuthContext } from '@/hooks/useAuthContext';
import type { AuthUser } from '@/types';

export function useCurrentUser(): AuthUser | null {
  const { user } = useAuthContext();
  return user;
}
